import { AnnouncementDetailPage } from './AnnouncementDetailPage';
export default AnnouncementDetailPage;
